export default __webpack_public_path__ + "static/media/cross_red.9617fcf5.svg";